







































































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import { clickOutside } from "@/shared/scripts/click-outside";

export default Vue.extend({
    name: "Dropdown",
    directives: {
        "click-outside": clickOutside
    },
    props: {
        toggleTitle: {
            type: String,
            required: false,
            default: ""
        },
        headerTitle: {
            type: String,
            required: true
        },
        toggleLabel: {
            type: String,
            required: false,
            default: ""
        },
        toggleStyle: {
            type: String,
            required: false,
            default: "dropdown__toggle"
        },
        isFullwidth: {
            type: Boolean,
            required: false,
            default: false
        },
        toggleIconVisible: {
            type: Boolean,
            required: false,
            default: true
        },
        nested: {
            type: Boolean,
            required: false,
            default: false
        },
        closeLabel: {
            type: String,
            required: false,
            default: "Close Dropdown"
        },
        isAModalOpen: {
            type: Boolean,
            required: false,
            default: false
        },
        mobileBreakpoint: {
            type: String,
            required: false,
            default: "to-desktop"
        },
        inactiveBreakpoint: {
            type: String,
            required: false,
            default: "none"
        },
        isInvisible: {
            type: Boolean,
            required: false,
            default : false
        }
    },
    data: function() {
        return {
            listOpen: false,
            firstFocusableElement: undefined as undefined | HTMLElement,
            lastFocusableElement: undefined as undefined | HTMLElement,
            documentScrollTop: null as null | number,
            isMobile: false,
            uniqueId: uuidv4(),
            isActive: true
        };
    },
    computed: {
        hasToggleTitleSlot: function(): boolean {
            return !!this.$slots["toggleTitle"];
        },
        hasFooterSlot: function(): boolean {
            return !!this.$slots["footer"];
        },
    },
    mounted: function() {
        // Responsive Behavior
        /* istanbul ignore next */
        this.$responsive.registerMediaQuery(this.mobileBreakpoint, () => {
            if(!document.documentElement.classList.contains("js-fullscreen") && this.listOpen){
                this.documentScrollTop = (
                    document.scrollingElement ||
                    document.documentElement ||
                    document.body.parentNode ||
                    document.body
                ).scrollTop;
                // Add a Modal-Open class on html tag (disable scroll in css)
                document.documentElement.classList.add("js-fullscreen");
            }
            this.isMobile = true;
        }, () => {
            if(document.documentElement.classList.contains("js-fullscreen") && this.listOpen){
                // Remove Modal-Open class on html tag
                document.documentElement.classList.remove("js-fullscreen");
            }
            this.isMobile = false;
        });

        if (this.inactiveBreakpoint !== "none") {
            this.$responsive.registerMediaQuery(this.inactiveBreakpoint, () => {
                this.isActive = false;
            }, () => {
                this.isActive = true;
            });
        }
    },
    methods: {
        toggleList: function() {
            if (this.listOpen === true) {
                this.closeList();
            } else {
                this.openList();
            }
        },
        openList: function() {
            const dropdownBody = this.$el.querySelector(".dropdown__body");

            if (dropdownBody) {
                const focusablesElementsNodeList = dropdownBody.querySelectorAll(
                    "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]"
                );

                if (focusablesElementsNodeList) {
                    const focusableElements = Array.from(focusablesElementsNodeList) as Array<HTMLElement>;

                    this.firstFocusableElement = focusableElements[0];

                    // Save last focusable element of the modal
                    this.lastFocusableElement = focusableElements.pop();

                    if(this.isMobile){
                        this.documentScrollTop = (
                            document.scrollingElement ||
                            document.documentElement ||
                            document.body.parentNode ||
                            document.body
                        ).scrollTop;
                        // Add a Modal-Open class on html tag (disable scroll in css)
                        if(!document.documentElement.classList.contains("js-fullscreen")){
                            document.documentElement.classList.add("js-fullscreen");
                        }

                        if(this.nested) {
                            document.documentElement.classList.add("js-fullscreen--nested");
                        }
                    }
                    this.listOpen = true;
                    this.$emit("click");

                    Vue.nextTick(() => {
                        if (this.firstFocusableElement) {
                            this.firstFocusableElement.focus();
                        }
                    });
                }
            }
        },
        closeList: function() {
            this.closeListWithoutRefresh();
            this.$emit("closeList");
        },
        closeListWithoutRefresh: function() {
            if( this.listOpen === true && this.isAModalOpen === false) {

                if(this.isMobile && (document.documentElement.classList.contains("js-fullscreen") || document.documentElement.classList.contains("js-fullscreen--nested"))){

                    if (this.documentScrollTop) {
                        window.scroll(0, this.documentScrollTop);
                    }

                    if(this.nested) {
                        document.documentElement.classList.remove("js-fullscreen--nested");
                    } else {
                        document.documentElement.classList.remove("js-fullscreen");
                    }
                }
                this.listOpen = false;
            }
        },
        handleTabPress: function(event: KeyboardEvent) {
            if(document.documentElement.classList.contains("js-fullscreen")) {
                if (event.shiftKey === true) {
                    //Tab backward
                    if (document.activeElement === this.firstFocusableElement) {
                        event.preventDefault();
                        if (this.lastFocusableElement) {
                            this.lastFocusableElement.focus();
                        }
                    }
                } else {
                    // Tab forward
                    if (document.activeElement === this.lastFocusableElement) {

                        event.preventDefault();
                        if (this.firstFocusableElement) {
                            this.firstFocusableElement.focus();
                        }
                    }
                }
            }
        },
        handleClickaway: function() {
            if(this.isMobile === false && this.listOpen) {
                this.closeList();
            }
        },
    },
});
